<h3 class="ui primary header">
  New Chat
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div class="content">
  <div class="ui basic vertical segment">
    <div
      class="ui form"
      [formGroup]="servicesAndSubGroupsForm"
      [ngClass]="{ loading: pending }"
    >
      <!-- add validation -->
      <!-- <div class="ui input"> -->
      <label class="selection-header-label" style="margin-top: 5px"
        >Which of these service would you like to enquire about?
        <span class="required-input">*</span></label
      >
      <div class="field" *ngFor="let topic of allTopics">
        <sui-radio-button
          [name]="'example'"
          [value]="topic.topicId"
          formControlName="serviceType"
          [(ngModel)]="selectedServiceType"
          (click)="changeType(topic.topicId)"
        >
          {{ topic.topic }}
        </sui-radio-button>
      </div>
      <div *ngIf="selectedServiceType">
        <div class="sub-category">
          <label class="selection-header-label">
            Which of these sub-service would you like to enquire about?
            <span class="required-input">*</span></label
          >
          <div class="field" *ngFor="let sub_topic of filteredSubTopics">
            <sui-radio-button
              [name]="'example1'"
              [value]="sub_topic.subtopicId"
              formControlName="subServiceType"
              [(ngModel)]="selectedServiceSubType"
            >
              {{ sub_topic.subtopic }}
            </sui-radio-button>
          </div>
          <div class="field" *ngIf="filteredSubTopics.length < 1">
            <p>There is no Sub services under this service</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button
      class="ui primary button"
      [ngClass]="{ loading: pending }"
      (click)="submit()"
      autofocus
      [disabled]="!selectedServiceSubType"
    >
      Continue
    </button>
  </div>
</div>
